<template>
    <div class="quotation">
        <h1>价格计算</h1>
        <div class="form">
            <dl>
                <dt>产品类别</dt>
                <template v-for="value in list">
                    <dd v-if="config.shares.length > 0">
                        <div class="product-type-item" v-if="config.shares.includes(value.sort)"><span
                                @click="goTo(value)">{{ value.name }}</span><span v-if="userInfo && userInfo.nickName"
                                @click="edit(value.sort)">编辑</span>
                        </div>
                    </dd>
                    <dd v-else>
                        <div class="product-type-item">
                            <span> <input type="checkbox" name="value.sort" v-model="value.checked"
                                    v-if="config.shares.length == 0" />
                                <span @click="goTo(value)">{{ value.name }}</span></span> <span
                                v-if="userInfo && userInfo.nickName" @click="edit(value.sort)">编辑</span>
                        </div>
                    </dd>
                </template>
            </dl>
        </div>
        <br />
        <br />
        <div class="button-wapper" v-if="config.shares.length == 0">
            <span v-if="userInfo && userInfo.nickName" class="btn btn-big" @click="save">确 定</span>
        </div>
        <div class="quotaion-form" v-show="quotationShow">
            <h2 class="title">{{ title }}</h2>
            <div class="form">
                <div class="form-item">
                    <label>合伙人</label>
                    ：<input v-model="form.receiver" type="text" />

                </div>
                <div style="display: none;" class="form-item">
                    <label>产品类型</label>
                    ：<input v-model="form.productType" type="text" />
                </div>
                <div class="form-item">
                    <label>材料系数</label>
                    ：<input v-model="form.materialFactor" type="text" />
                </div>
                <div class="form-item">
                    <label>附加值</label>
                    ：<input v-model="form.incrementalValue" type="text" />
                </div>
                <div class="form-item">
                    <label>原始价</label>
                    ：<input v-model="form.originalPrice" type="text" />
                </div>
                <div class="form-item">
                    <label>报价间隔</label>
                    ：<input v-model="form.quotationInterval" type="text" />
                </div>
                <div class="form-item">
                    <label>报价包含</label>
                    ：<input v-model="form.quotationInclude" type="text" />
                </div>
                <div class="form-item">
                    <label>一次性订货量</label>
                    ：<input v-model="form.orderQuantity" type="text" />
                </div>
                <div class="form-item">
                    <label>分成比例</label>
                    ：<input style="opacity: 0;" v-model="form.expandJson" type="text" />
                    <div style="width: 83%; text-align: left;margin-left: 1.3rem;">
                        <div v-for="(value, _key) in proportion"
                            style="width:50%;display: inline-block; margin-bottom: 5px;">
                            <span style=" width:1.3rem; display: inline-block; text-align: right;">{{
                                Object.keys(value)[0]
                            }}：</span><input v-model="proportion[_key][Object.keys(value)]" type="text"
                                style="width:calc(100% - 2rem);display: inline-block;" />
                        </div>
                    </div>
                </div>
                <div class="form-item">
                    <label>说明</label>
                    ：<input style="opacity: 0;" v-model="form.remark" type="text" />
                </div>
                <div style="text-align: center;">
                    <textarea style="width: 83%; text-align: left;" rows="10" v-model="form.remark" type="text" />
                </div>
                <br />
            </div>
            <br />
            <div class="btns">
                <span class="btn btn-big cancel" @click="quotationShow = false">取 消</span>
                <span class="btn btn-big" @click="submit">保 存</span>
            </div>
        </div>
    </div>
</template>
<script>
import { getDocQuotationReceiver, updateDocQuotationReceiver, getInfo } from "@/api/docQuotationReceiver";
import { listDocQuotationCalculation, getDocQuotationCalculation, updateDocQuotationCalculation, addDocQuotationCalculation } from "@/api/docQuotationCalculation"
export default {
    data() {
        return {
            config: { shares: [0] },
            form: {
                single: "",
                weight: "",
                year: 1
            },
            userInfo: {},
            quotationCalculationForm: {},
            resultShow: false,
            resultValue: 0,
            list: [
                { checked: false, sort: '1', name: '1. 白卡纸（纸盒/吊牌/挂牌）' },
                { checked: false, sort: '2', name: '2. 不干胶（标签/瓶贴）' },
                { checked: false, sort: '3', name: '3. 单张纸（合格证/说明书/浆糊瓶贴等）' },
                { checked: false, sort: '4', name: '4. 封箱带' },
                { checked: false, sort: '5', name: '5. 瓦楞纸箱面纸' },
                { checked: false, sort: '6.1', name: '6.1 烟包硬盒框架纸' },
                { checked: false, sort: '6.2', name: '6.2 烟包硬盒环保铝箔衬纸' },
                { checked: false, sort: '6.3', name: '6.3 烟包硬盒外壳' },
                { checked: false, sort: '6.4', name: '6.4 烟包软包封签纸' },
                { checked: false, sort: '6.5', name: '6.5 烟包全开硬盒内卡纸' }],
            quotationCalculationList: [],
            quotationShow: false,
            proportion: [],
            title: '新增报价系数',
            formTemplate: {
                expandJson: "{\"scales\":[{\"基价1\":\"10\"},{\"阶段1\":\"20\"},{\"阶段2\":\"30\"},{\"阶段3\":\"40\"},{\"阶段4\":\"50\"}],\"shares\":[]}",
                id: "1772029131145",
                incrementalValue: "0.03",
                materialFactor: "0.0005",
                orderQuantity: "100万个",
                originalPrice: 0.00015,
                productType: "白板纸",
                quotationInclude: "纤维白卡纸",
                quotationInterval: "1.5",
                remark: "1.一次订量低于等于5万个，报价增加1元；\n2.一次订量大于5万个~10万个，报价增加0.8元；\n3.一次订量大于10万个~50万个，报价增加0.6元；\n4.一次订量大于50万个~100万个，报价增加0.4元；\n5.一次订量大于100万个~200万个，报价增加0.2元；\n6.一次订货大于200万个~500万个，报价增加0.1元；\n7.一次订货大于500万个以上，报价不增加。\n8.甲方认为合伙人报价过低时，保留调整的权利。"
            }
        }
    },
    created() {
        getInfo().then(res => {
            // console.log(res)
            if (res && res.code == 200)
                this.userInfo = res.user || {}
        })

        this.getList()
    },
    methods: {
        getList() {
            getDocQuotationReceiver(this.$route.query._).then(res => {
                this.receiverForm = res.data
                this.config = JSON.parse(res.data.exendJson || '{"shares":[]}')
            })
            listDocQuotationCalculation({ receiverId: this.$route.query._, pageNum: 1, pageSize: 100 }).then(res => {
                this.quotationCalculationList = res.rows
                // this.config = JSON.parse(res.data.expandJson)
                // console.log(this.config)
                // this.formTemplate.expandJson = JSON.stringify({ scales: this.proportion, shares: [] })
            })
        },
        goTo(item) {
            let obj = this.quotationCalculationList.find(quo => quo.productType == item.sort)
            if (obj)
                this.$router.push({ path: '/quotation-item', query: { sort: item.sort, title: item.name, _: obj.id } })
            else {
                this.formTemplate.id = new Date().getTime() + ''
                this.formTemplate.productType = item.sort
                this.formTemplate.receiverId = this.$route.query._
                this.formTemplate.receiver = this.receiverForm.receiver
                addDocQuotationCalculation(this.formTemplate).then(res => {
                    this.$router.push({ path: '/quotation-item', query: { sort: item.sort, title: item.name, _: this.formTemplate.id } })
                })
            }
        },
        save() {
            let _shares = this.list.filter(item => item.checked).map(item => item.sort)
            this.config.shares = _shares
            this.receiverForm.exendJson = JSON.stringify(this.config)
            updateDocQuotationReceiver(this.receiverForm).then(res => {

            })
        },
        edit(type) {
            let obj = this.quotationCalculationList.find(item => item.productType == type)
            this.form = obj || Object.assign(this.formTemplate, { receiver: this.receiverForm.receiver, productType: type })
            if (obj)
                this.proportion = JSON.parse(this.form.expandJson).scales
            else
                this.proportion = [{ '基价1': '10' }, { '阶段1': '20' }, { '阶段2': '30' }, { '阶段3': '40' }, { '阶段4': '50' }]
            // this.form.productType = type
            this.quotationShow = true
            // this.form = {}
        },
        submit() {
            if (this.form.id) {
                let _oldData = JSON.parse(this.form.expandJson)
                _oldData.scales = this.proportion
                this.form.expandJson = JSON.stringify(_oldData)
                updateDocQuotationCalculation(this.form).then(res => {
                    this.quotationShow = false
                    this.getList()
                })
            } else {
                this.form.expandJson = JSON.stringify({ scales: this.proportion, shares: [] })
                this.form.id = new Date().getTime() + ''
                this.form.receiverId = this.$route.query._
                addDocQuotationCalculation(this.form).then(res => {
                    this.quotationShow = false
                    this.getList()
                })
            }
            console.log(this.form)
        }
    }
}
</script>
<style lang="scss" scoped>
.quotation {
    padding: 0.32rem;
    font-size: .4rem;

    .title,
    h1,
    .button {
        text-align: center;
    }

    h1 {
        font-size: 0.64rem;
        line-height: 2rem;
    }

    dd {
        color: #409eff;
    }

    dt {
        text-align: center;
        line-height: 0.8rem;
    }

    .product-type-item {
        display: grid;
        grid-template-columns: 1fr 40px;
    }

    .quotaion-form {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: #fff;
        overflow-y: auto;

        h2 {
            line-height: 2rem;
        }

        .btns {
            text-align: center;
        }
    }

    .form {
        dd {
            line-height: 1rem;
        }

        font-size: 0.35rem;

        .form-item {
            padding-bottom: 10px;

            label {
                display: inline-block;
                width: 2.2rem;
                text-align: right;
                vertical-align: middle;
            }
        }

        input[type='text'],
        textarea {
            padding: 4px 8px;
            text-align: center;
            width: calc(100% - 3.8rem);
        }
    }

    .button-wapper {
        text-align: center;
    }

    .btn {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        background: #fff;
        border: 1px solid #dcdfe6;
        color: #606266;
        -webkit-appearance: none;
        text-align: center;
        box-sizing: border-box;
        outline: none;
        margin: 0;
        transition: 0.1s;
        font-weight: 500;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        padding: 0.1rem 0.2rem;
        font-size: 0.26rem;
        border-radius: 4px;
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
    }

    .btn-remove {
        background-color: #F56C6C;
        border-color: #F56C6C;
    }

    .btn-big {
        padding: 0.2rem 0.4rem;
        font-size: 0.3rem;
    }

    .cancel {
        background-color: #c0c2c4;
        border-color: #c0c2c4;
    }

    .tip {
        font-size: 14px;
        line-height: 0.6rem;
    }

    .result {
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: #dcdfe6;
        padding: 16px;
        text-align: center;
        box-sizing: border-box;

        .button-result {
            width: 100%;
            height: 80px;
            position: absolute;
            bottom: 0;
            margin-left: -16px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/quotation2/index.vue